import { fb, validators } from 'form';

export function getProductEditModel(data) {

  const model = fb.group({
    productName: [data.productName || '', [validators.Required()], { type: 'text' }],
  })

  return model;
}
